
import { Component, Prop, Vue } from "vue-property-decorator";
import Item from "../item.vue";
import Comp1 from "./Comp1.vue";
import Comp2 from "./Comp2.vue";
import Comp3 from "./Comp3.vue";

import ResTxt from "./ResTxt.vue";
import {
  CandidateNewResult,
  DimensionGroupConfig,
  DimensionReportConfig
} from "@/lib/model/exam/candidate-result";

@Component({
  components: { Item, Comp1, Comp2, Comp3, ResTxt }
})
export default class Appendix extends Vue {
  @Prop({ default: () => new CandidateNewResult() }) all!: CandidateNewResult;
  TYPE1 = 1; // 通用能力
  TYPE2 = 2; // 岗位匹配度
  TYPE3 = 3; // 职业规划解读 code
  TYPE4 = 4; // 进阶能力 code

  get dimensionReportGroup(): DimensionGroupConfig[] {
    return this.all.report.dimensionGroupList;
  }

  get dimensionList(): DimensionReportConfig[] {
    const dimensionList: DimensionReportConfig[] = [];
    const groups = this.dimensionReportGroup.filter(group => {
      return +group.readingGuidelinesType === this.TYPE1;
    });
    if (groups.length) {
      groups.forEach(group => {
        dimensionList.push(...group.dimensionList);
      });
    }
    return dimensionList;
  }
  get isShowType1(): boolean {
    return this.isShowReadingGuideLinesByType(this.TYPE1);
  }
  get isShowType2(): boolean {
    return this.isShowReadingGuideLinesByType(this.TYPE2);
  }
  get isShowType3(): boolean {
    return this.isShowReadingGuideLinesByType(this.TYPE3);
  }
  get isShowType4(): boolean {
    return this.isShowReadingGuideLinesByType(this.TYPE4);
  }

  // 根据type判断是否显示当前条目
  isShowReadingGuideLinesByType(type: number): boolean {
    const obj = this.dimensionReportGroup?.find(
      ele => +ele.readingGuidelinesType === type
    );
    return !!obj;
  }

  // 进阶能力维度组
  get groupList(): DimensionGroupConfig[] {
    const groupList: DimensionGroupConfig[] = [];
    const groups = this.dimensionReportGroup.filter(group => {
      return +group.readingGuidelinesType === 4;
    });
    if (groups.length) {
      groups.forEach(group => {
        groupList.push(group);
      });
    }
    return groupList;
  }
}
